import { useEffect, useMemo } from "react";
import { useAvailableLinesStore } from "../../stores/hashs/useAvailableLinesStore";
import { useDateStore } from "../../stores/useDateStore";
import { useNotEscaletedLinesNextStore } from "../../stores/hashs/useNotEscaletedLinesNextStore";

export function useNotEscaletedLinesNext() {

    const {
        data: availableLines,
        totalNext
    } = useAvailableLinesStore();

    const nextDayLabel = useDateStore(state => state.nextDayLabel);

    const setNotEscaletedLinesNext =
        useNotEscaletedLinesNextStore(
            state => state.setNotEscaletedLinesNext
        );

    const value = useMemo(() => {

        const data = [];

        for (const linha of availableLines) {
            if (!linha.next || linha.isEscaladaNext) {
                continue;
            }

            data.push(linha);
        }

        const total = data.length;

        return {
            data,
            total,
            totalDay: totalNext,
            percentTotal:
                totalNext
                    ? Math.round(total / totalNext * 100)
                    : 0,
            title:
                `LINHA${total > 1 ? 'S' : ''} NÃO ESCALADA${total > 1 ? 'S' : ''} PARA ${nextDayLabel}`
        };

    }, [
        availableLines,
        totalNext,
        nextDayLabel
    ]);

    useEffect(() => {

        setNotEscaletedLinesNext(value);

    }, [
        value,
        setNotEscaletedLinesNext
    ]);

}